import { render, staticRenderFns } from "./device_s4.vue?vue&type=template&id=1f498f8c&scoped=true&"
import script from "./device_s4.vue?vue&type=script&lang=js&"
export * from "./device_s4.vue?vue&type=script&lang=js&"
import style0 from "./device_s4.vue?vue&type=style&index=0&id=1f498f8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f498f8c",
  null
  
)

export default component.exports